<ion-header class="ion-no-border" [translucent]="true" joyrideStep="student-overview" title="Übersicht" text="Auf dieser Seite findest du eine Übersicht aller deiner Fahrschüler.">
  <ion-toolbar>
    <ion-title> Fahrschüler </ion-title>
    <ion-buttons slot="end">
      @if (!isSelection()) {
      <ion-button (click)="generateReport()" joyrideStep="print-student-report" title="Bericht drucken" text="Diese Funktion findest du an mehreren Stellen in der App. Hier kannst du mit einem Klick verschiedene Auswertungen und Statistiken zu deinen Fahrschülern erstellen, die du als PDF herunterladen oder per E-Mail versenden kannst.">
        <ion-icon slot="icon-only" name="print"></ion-icon>
      </ion-button>
    }
      <ion-button (click)="openStudentModal()" joyrideStep="add-student" title="Fahrschüler hinzufügen" text="Lass uns einen neuen Fahrschüler kennenlernen!" (done)="openStudentModal()">
        <ion-icon slot="icon-only" name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      class="custom-searchbar"
      [(ngModel)]="filterTerm"
      placeholder="Suchen"
    ></ion-searchbar>
  </ion-toolbar>
  @if (!isSelection()) {
  <ion-toolbar joyrideStep="archived-students" title="Archivierte Fahrschüler" text="Du hast die Möglichkeit, Fahrschüler zu archivieren. Diese werden dann in einer separaten Fahrschülerliste angezeigt." class="toolbar">
    <ion-item button (click)="openArchivedStudents()" detail="true" lines="full" class="sticky toolbar-item">
      <ion-label>Archivierte Fahrschüler</ion-label>
      <ion-badge mode="ios" color="primary"></ion-badge>
    </ion-item>
  </ion-toolbar>
  }
</ion-header>

<ion-content>
  @if (!isSelection()) {
  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content> </ion-refresher-content>
  </ion-refresher>
  }
  <ion-list lines="none" class="dark:bg-darklist p-0">
    @for (section of sections() | filterSections:filterTerm; track
    trackByFn(section)) {
    <ion-item-group>
      <ion-item-divider sticky>
        <ion-label>{{ section.letter }}</ion-label>
      </ion-item-divider>
      @for (student of section.students; track student?.student_id) {
      <ion-item
        button
        (click)="studentClicked(student)"
        detail="false"
        lines="none"
        class="avatar"
      >
        <app-avatar class="mr-3 grid" [student]="student"></app-avatar>
        @if (student?.mobile_no) {
        <ion-label>
          <h3>{{student?.forename}} {{student?.surname}}</h3>
          <p>{{student?.mobile_no || "&#8205;"}}</p>
        </ion-label>
        } @else {
        <ion-label class="py-3">
          <h3>{{student?.forename}} {{student?.surname}}</h3>
        </ion-label>
        }
      </ion-item>
      }
    </ion-item-group>
    }
  </ion-list>
  @if (!sections() || !sections().length) {
    <app-no-selection
      label="Keine Fahrschüler"
      icon="people-circle"
      color="medium"
      class="h-full"
      [studentsTutorial]="!isSelection()"
    ></app-no-selection>
  }
</ion-content>
